function chooseWeighted(rewards) {
    var sum = rewards.reduce((acc, reward) => acc + reward.likelihood, 0);
    
    var probabilityAmount = 0;
    var chances = rewards.map(reward => (probabilityAmount = reward.likelihood + probabilityAmount));

    var rand = Math.random() * sum;

    return rewards[chances.filter(chance => chance <= rand).length];
}

function reward(solution) {
    let cash = Math.floor(2.5 * solution.length);

    let moreCash = Math.floor(cash * 1.5);
    let moreCashCeil = Math.floor(cash * 1.5);
    let almostNoCash = Math.floor(cash * 0.2);
    let lotsMoreCash = Math.ceil(cash * 2.5);

    let rewards = [
        { title: "Straight_Cash_V1", note: `€\$${cash} credited to your account`, cash, likelihood: 35 },
        { title: "Straight_Cash_V2", note: `Leech slightly more cash than normal. €\$${cash}`, cash: moreCash, likelihood: 4 },
        { title: "Straight_Cash_V2.5", note: `Leech more cash than normal. €\$${cash}`, cash: moreCashCeil, likelihood: 3 },
        { title: "Cash_Sap_V1", note: `€\$${cash} leaked from your account`, cash: -cash, likelihood: 4 },

        { title: "Buffer_Overflow_v1", note: `Gain an additional buffer slot`, cash: almostNoCash, bufferChange: +1, likelihood: 1 },
        { title: "Sequence_Extender_v1", note: `Add an additional sequence`, cash: almostNoCash, solutionChange: +1, likelihood: 2 },

        { title: "Scrambler_v1", note: `Add an additional hexcode. €\$${lotsMoreCash}`, cash: lotsMoreCash, characterChange: +1, likelihood: 1 },
        { title: "Descrambler_v1", note: `Remove a hexcode`, cash: almostNoCash, characterChange: -1, likelihood: 1 },
    ];

    return chooseWeighted(rewards);
}

function generatePuzzles(count, characters, maxLength, kindness = 0.4) {
    let puzzles = [];
    
    for (let i = 0; i < count; i++) {
        let solution = [];
        if (Math.random() < kindness & i > 0) {
            let lastPuzzleSolution = puzzles[i - 1].solution;
            solution[0] = lastPuzzleSolution[lastPuzzleSolution.length - 1];
        }

        let soluationLength = Math.max(Math.ceil(Math.random() * maxLength), 2);
        
        for (let s = 0; s < soluationLength; s++) {
            if (solution[s]) continue;

            solution[s] = characters[Math.floor(Math.random() * characters.length)];
        }
        
        puzzles[i] = { solution, progress: 0, status: 'pending', reward: reward(solution) };
    }
    
    return puzzles;
};

function checkProgressFromBuffer(puzzle, buffer) {
    puzzle.progress = 0;

    buffer.forEach((answer) => {
        if (answer == null) return;
        
        if (answer == puzzle.solution[puzzle.progress]) {
            puzzle.progress += 1;
        } else if (answer == puzzle.solution[0]) {
            puzzle.progress = 1;
        } else {
            puzzle.progress = 0;
        }
    });

    return puzzle;
}

export {checkProgressFromBuffer, generatePuzzles};